import React, { ComponentProps } from 'react'
import { useTranslation } from 'hooks/useTranslation'
import { DogBiologyRoot, Header, Feature, FeatureColumn, FeatureBox } from './DogBiology.styles'
import { Text } from 'components/Text'

type DogBiologyOwnProps = ComponentProps<typeof DogBiologyRoot>
export type DogBiologyProps = DogBiologyOwnProps & {}

export const DogBiology = (_props: DogBiologyProps) => {
  const { t } = useTranslation()

  return (
    <DogBiologyRoot>
      <Header>{t('products-v2:all-products.product-features.title')}</Header>
      <FeatureBox>
        <FeatureColumn>
          <Feature>
            <Text font='label' size='h5'>{t('products-v2:all-products.product-features.features.column-1.0.text')}</Text>
          </Feature>
          <Feature>
            <Text font='label' size='h5'>{t('products-v2:all-products.product-features.features.column-1.1.text')}</Text>
          </Feature>
          <Feature>
            <Text font='label' size='h5'>{t('products-v2:all-products.product-features.features.column-1.2.text')}</Text>
          </Feature>
        </FeatureColumn>
        <FeatureColumn>
          <Feature>
            <Text font='label' size='h5'>{t('products-v2:all-products.product-features.features.column-2.0.text')}</Text>
          </Feature>
          <Feature>
            <Text font='label' size='h5'>{t('products-v2:all-products.product-features.features.column-2.1.text')}</Text>
          </Feature>
          <Feature>
            <Text font='label' size='h5'>{t('products-v2:all-products.product-features.features.column-2.2.text')}</Text>
          </Feature>
        </FeatureColumn>
      </FeatureBox>
    </DogBiologyRoot>
  )
}

DogBiology.displayName = 'DogBiology'
